import React, { useState, useMemo, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./customStyles.css";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoMdArrowDropup } from "react-icons/io";
import moment from "moment";

const ReactTable = ({
  data,
  columns,
  previosyearData,
  priorWeekData,
  oneYearsHighest,
  oneYearlowest,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 20;
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState(1);

  useEffect(() => {
    const defaultSortField = "current_rigs";
    const defaultSortOrder = -1;

    setSortField(defaultSortField);
    setSortOrder(defaultSortOrder);
  }, []);
  // Handle sorting of the entire data
  const sortedData = useMemo(() => {
    let sorted = [...data];

    // Sort data based on the sortField and sortOrder
    if (sortField) {
      sorted.sort((a, b) => {
        const aValue = a[sortField];
        const bValue = b[sortField];

        if (aValue < bValue) return sortOrder === 1 ? -1 : 1;
        if (aValue > bValue) return sortOrder === 1 ? 1 : -1;
        return 0;
      });
    }

    return sorted;
  }, [data, sortField, sortOrder]);

  // Calculate the total number of pages
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  // Get the data to display for the current page
  const startIdx = currentPage * rowsPerPage;
  const endIdx = startIdx + rowsPerPage;
  const currentData = sortedData.slice(startIdx, endIdx);

  // Handle pagination change
  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  // Generate page numbers dynamically
  const pageNumbers = [];
  for (let i = 0; i < totalPages; i++) {
    pageNumbers.push(i + 1);
  }
  // Helper function to get the value for each field
  const getFieldValue = (field, rowData) => {
    // Determine the correct value based on the field
    if (field === "current_rigs") {
      return rowData[field];
    }

    if (field === "prior_week") {
      const priorWeekEntry = priorWeekData?.find(
        (item) => item.id === rowData.id
      );
      return priorWeekEntry ? priorWeekEntry.current_rigs : 0;
    }
    //margin

    if (field === "prior_wk_chg") {
      const currentRigs = rowData["current_rigs"];
      const priorWeekEntry = priorWeekData?.find(
        (item) => item.id === rowData.id
      );
      const priorWeek = priorWeekEntry ? priorWeekEntry.current_rigs : 0;

      return currentRigs - priorWeek; // Calculate the margin and display it
    }

    if (field === "prior_year") {
      const priorYearEntry = previosyearData?.find(
        (item) => item.id === rowData.id
      );
      return priorYearEntry ? priorYearEntry.current_rigs : 0;
    }

    //margin---
    if (field === "prior_yr_chg") {
      const currentRigs = rowData["current_rigs"];
      const priorYearsEntry = previosyearData?.find(
        (item) => item.id === rowData.id
      );
      const priorYears = priorYearsEntry ? priorYearsEntry.current_rigs : 0;
      return currentRigs - priorYears;
    }

    if (field === "52_wk_high") {
      const highEntry = oneYearsHighest?.find((item) => item.id === rowData.id);
      return highEntry ? highEntry.current_rigs : 0;
    }

    //margin---
    if (field === "52_wk_high_chg") {
      const currentRigs = rowData["current_rigs"];
      const priorYearsHigh = oneYearsHighest?.find(
        (item) => item.id === rowData.id
      );
      const oneYears = priorYearsHigh ? priorYearsHigh.current_rigs : 0;
      return currentRigs - oneYears;
    }

    if (field === "52_wk_low") {
      const lowEntry = oneYearlowest?.find((item) => item.id === rowData.id);
      return lowEntry ? lowEntry.current_rigs : 0;
    }

    //margin---
    if (field === "52_wk_low_chg") {
      const currentRigs = rowData["current_rigs"];
      const priorYearsLow = oneYearlowest?.find(
        (item) => item.id === rowData.id
      );
      const oneYearsLow = priorYearsLow ? priorYearsLow.current_rigs : 0;
      return currentRigs - oneYearsLow;
    }

    return rowData[field] || 0; // Default return value from rowData
  };

  const getQuantityColor = (quantity) => {
    if (quantity <= 0) return "rgb(30 30 30)"; // 0-0: #26363C
    if (quantity <= 5) return "#0FCAA8"; // 1-5: #0FCAA8

    if (quantity <= 10) return "#2CC6AA"; // 5-10: #2CC6AA
    if (quantity <= 20) return "#20A464"; // 11-20: #20A464
    if (quantity <= 30) return "#07B2A8"; // 21-30: #07B2A8
    if (quantity <= 40) return "#0D6579"; // 31-40: #0D6579
    if (quantity <= 50) return "#48CAE4"; // 41-50: #48CAE4
    if (quantity <= 60) return "#00B4D8"; // 51-60: #00B4D8
    if (quantity <= 70) return "#0096C7"; // 61-70: #0096C7
    if (quantity <= 80) return "#0077B6"; // 71-80: #0077B6
    if (quantity <= 90) return "#023E8A"; // 81-90: #023E8A
    if (quantity <= 100) return "#03045E"; // 91-100: #03045E
    return "#67B100"; // Greater than 100: #67B100
  };

  const calculateColumnTotals = () => {
    const totals = {};
    columns.forEach((col) => {
      if (
        (col.field &&
          (col.field === "current_rigs" ||
            col.field === "prior_week" ||
            col.field === "prior_year" ||
            col.field === "52_wk_high" ||
            col.field === "52_wk_low")) ||
        col.field === "prior_wk_chg" ||
        col.field === "prior_yr_chg" ||
        col.field === "52_wk_high_chg" ||
        col.field === "52_wk_low_chg"
      ) {
        totals[col.field] = sortedData.reduce(
          (sum, row) => sum + (row[col.field] || 0),
          0
        );
      }
    });
    return totals;
  };
  const columnTotals = calculateColumnTotals();

  // Custom Header with Titles
  const header = (
    <div
      className="table-header"
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        fontSize: "22px",
        fontWeight: 500,
      }}
    >
      <div>Active Rig Count</div>
      <div>Rig Count Changes</div>
    </div>
  );

  return (
    <div className="card">
      <DataTable
        value={currentData}
        header={header}
        tableStyle={{ minWidth: "50rem" }}
        sortField={sortField}
        sortOrder={sortOrder}
        onSort={(e) => {
          setSortField(e.sortField);
          setSortOrder(e.sortOrder);
        }}
      >
        {columns?.map((col, index) => {
          if (col.field === "current_rigs") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const quantity = rowData[col.field];
                  const backgroundColor = getQuantityColor(quantity);
                  return (
                    <div
                      style={{
                        backgroundColor: backgroundColor,
                        padding: "5px 0px",
                        color: "#fff",
                        textAlign: "center",
                        minHeight: "32px",
                        marginLeft: "3px",
                      }}
                    >
                      {quantity ? quantity : 0}
                    </div>
                  );
                }}
              />
            );
          }
          //------------update------------
          if (col.field === "prior_week") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const quantity = rowData[col.field];
                  const backgroundColor = getQuantityColor(quantity);
                  return (
                    <div
                      style={{
                        backgroundColor: backgroundColor,
                        padding: "5px 0px",
                        color: "#fff",
                        textAlign: "center",
                        minHeight: "32px",
                      }}
                    >
                      {quantity ? quantity : 0}
                    </div>
                  );
                }}
              />
            );
          }
          if (col.field === "prior_year") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const quantity = rowData[col.field];
                  const backgroundColor = getQuantityColor(quantity);

                  return (
                    <div
                      style={{
                        backgroundColor: backgroundColor,
                        padding: "5px 0px",
                        color: "#fff",
                        textAlign: "center",
                        minHeight: "32px",
                      }}
                    >
                      {quantity ? quantity : 0}
                    </div>
                  );
                }}
              />
            );
          }
          if (col.field === "52_wk_high") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const quantity = rowData[col.field];
                  const backgroundColor = getQuantityColor(quantity);

                  return (
                    <div
                      style={{
                        backgroundColor,
                        padding: "5px 0px",
                        color: "#fff",
                        textAlign: "center",
                        minHeight: "32px",
                      }}
                    >
                      {quantity ? quantity : 0}
                    </div>
                  );
                }}
              />
            );
          }

          if (col.field === "52_wk_low") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const quantity = rowData[col.field];
                  const backgroundColor = getQuantityColor(quantity);

                  return (
                    <div
                      style={{
                        backgroundColor,
                        padding: "5px 0px",
                        color: "#fff",
                        textAlign: "center",
                        minHeight: "32px",
                      }}
                    >
                      {quantity ? quantity : 0}
                    </div>
                  );
                }}
              />
            );
          }

          if (col.field === "prior_wk_chg") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const currentRigs = rowData["current_rigs"];
                  const quantity = rowData[col.field];

                  let margin = currentRigs - quantity;
                  return (
                    <div
                      style={{
                        textAlign: "center",

                        color:
                          currentRigs > margin
                            ? "#00c90a"
                            : currentRigs < margin
                              ? "#b90000"
                              : "#c1c1c1",
                      }}
                    >
                      {quantity ? quantity : 0}
                      {currentRigs > margin ? (
                        <IoMdArrowDropup />
                      ) : currentRigs < margin ? (
                        <IoMdArrowDropdown />
                      ) : null}
                    </div>
                  );
                }}
              />
            );
          }

          if (col.field === "prior_yr_chg") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const currentRigs = rowData["current_rigs"];
                  const quantity = rowData[col.field];

                  let margin = currentRigs - quantity;
                  return (
                    <div
                      style={{
                        textAlign: "center",
                        color:
                          currentRigs > margin
                            ? "#00c90a"
                            : currentRigs < margin
                              ? "#b90000"
                              : "#c1c1c1",
                      }}
                    >
                      {quantity ? quantity : 0}
                      {currentRigs > margin ? (
                        <IoMdArrowDropup />
                      ) : currentRigs < margin ? (
                        <IoMdArrowDropdown />
                      ) : null}
                    </div>
                  );
                }}
              />
            );
          }

          if (col.field === "52_wk_high_chg") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const currentRigs = rowData["current_rigs"];
                  const quantity = rowData[col.field];

                  let margin = currentRigs - quantity;
                  return (
                    <div
                      style={{
                        textAlign: "center",
                        color:
                          currentRigs > margin
                            ? "#00c90a"
                            : currentRigs < margin
                              ? "#b90000"
                              : "#c1c1c1",
                      }}
                    >
                      {quantity ? quantity : 0}
                      {currentRigs > margin ? (
                        <IoMdArrowDropup />
                      ) : currentRigs < margin ? (
                        <IoMdArrowDropdown />
                      ) : null}
                    </div>
                  );
                }}
              />
            );
          }
          //------------------11/26/2024

          if (col.field === "52_wk_low_chg") {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const currentRigs = rowData["current_rigs"];
                  const quantity = rowData[col.field];

                  let margin = currentRigs - quantity;

                  return (
                    <div
                      style={{
                        textAlign: "center",
                        color:
                          currentRigs > margin
                            ? "#00c90a"
                            : currentRigs < margin
                              ? "#b90000"
                              : "#c1c1c1",
                      }}
                    >
                      {quantity ? quantity : 0}
                      {currentRigs > margin ? (
                        <IoMdArrowDropup />
                      ) : currentRigs < margin ? (
                        <IoMdArrowDropdown />
                      ) : null}
                    </div>
                  );
                }}
              />
            );
          }

          if (
            col.field === "basin" ||
            col.field === "state" ||
            col.field === "county"
          ) {
            return (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={(rowData) => {
                  const quantity = rowData[col.field];
                  return (
                    <div
                      style={{
                        padding: "5px 0px",
                        color: "#fff", // White text for contrast
                        // minHeight: "32px",
                        width: "160px",
                        marginLeft: "6px",
                      }}
                    >
                      {quantity ? quantity : "-"}
                    </div>
                  );
                }}
              />
            );
          }

          return (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable={col.sortable}
              style={col.style}
            />
          );
        })}
      </DataTable>

      <div
        className="total-row"
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          background: "#1b282f",
          color: "white",
          padding: "10px 0",
          // fontWeight: 500,
          // fontSize: "14px",
        }}
      >
        <div
          style={{
            display: "flex",
            // justifyContent: "space-between",
            // width: "80%",
            // marginLeft: "160px",
            justifyContent: "space-around",
            width: "100%",
            marginLeft: "175px",
          }}
        >
          {" "}
          <div style={{ display: "flex", width: "8%" }}>Total</div>
          {columns.map((col, index) => {
            return (
              <div
                key={index}
                style={{
                  textAlign: "center",
                  width: "14%",
                  // marginLeft: "10px",
                }}
              >
                {columnTotals[col.field] !== undefined
                  ? columnTotals[col.field]
                  : ""}
                {col.field === "prior_wk_chg" ||
                  col.field === "prior_yr_chg" ||
                  col.field === "52_wk_high_chg" ? (
                  <IoMdArrowDropdown />
                ) : col.field === "52_wk_low_chg" ? (
                  <IoMdArrowDropup />
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div
        className="pagination-container"
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          background: "#1b282f",
        }}
      >
        <span style={{ color: "grey", fontWeight: 500, alignSelf: "center" }}>
          {startIdx + 1}–{Math.min(endIdx, data.length)} of {data.length} rows
        </span>
        <div style={{ display: "flex", alignItems: "center" }}>
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 0}
            className="p-button p-button-text"
          >
            Previous
          </button>

          {currentPage > 2 && (
            <>
              <button
                onClick={() => onPageChange(0)}
                className="p-button p-button-text"
              >
                1
              </button>
              <span style={{ padding: "0 5px" }}>...</span>
            </>
          )}

          {pageNumbers
            .slice(
              Math.max(0, currentPage - 2),
              Math.min(totalPages, currentPage + 3)
            )
            .map((pageNumber) => (
              <button
                key={pageNumber}
                onClick={() => onPageChange(pageNumber - 1)}
                className={`p-button p-button-text ${pageNumber - 1 === currentPage ? "p-button-outlined" : ""
                  }`}
              >
                {pageNumber}
              </button>
            ))}

          {currentPage < totalPages - 3 && (
            <>
              <span style={{ padding: "0 5px", color: "white" }}>...</span>
              <button
                onClick={() => onPageChange(totalPages - 1)}
                className="p-button p-button-text"
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages - 1}
            className="p-button p-button-text"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReactTable;
